module.exports = __webpack_public_path__ + "static/media/Armghan_Haider_Resume_2019.a8d60ffd.pdf";